import type { WorkflowRunDocumentPayload } from '@Application/WorkflowRuns/WorkflowRun/Actions/workflowRunFetched';
import LabeledValueView from '@UI/Store/Shared/Views/LabeledValueView';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * One document of a run. `stage` is 0-indexed (displayed `stage + 1`). `stepId` is the definition,
 * `stepRunId` the execution (`null` before launch; retrying targets it). `canRetry` and `failureMessage`
 * are decided by the server.
 */
class WorkflowRunDocumentView {
	readonly stage: number;
	readonly stepId: number;
	readonly stepRunId: number | null;
	readonly documentTypeId: number;
	readonly documentId: number | null;
	readonly state: LabeledValueView;
	readonly canRetry: boolean;
	readonly failureMessage: string | null;

	constructor(payload: WorkflowRunDocumentPayload) {
		this.stage = payload.stage;
		this.stepId = payload.step.id;
		this.stepRunId = payload.stepRun?.id ?? null;
		this.documentTypeId = payload.documentType.id;
		this.documentId = payload.document?.id ?? null;
		this.state = new LabeledValueView(payload.state);
		this.canRetry = payload.canRetry;
		this.failureMessage = payload.failureMessage;

		Object.freeze(this);
	}

	get isFailed(): boolean {
		return this.state.value === 'failed';
	}

	get isToReview(): boolean {
		return this.state.value === 'to_review';
	}
}

export default WorkflowRunDocumentView;
